export default class ConfigConnection {
  // Prod API
  // apiInstance = "http://localhost:3000/";
  // Dev API
  apiInstance = "https://socialdoctor.mx:4455/";
}
